import { Collections, type PortsResponse } from '@/pocketbase/pocketbase-types';
import { pb } from '@/utils/ApiClient';
import { getContext, setContext } from 'svelte';

export class PortRepository {
	ports = $state<PortsResponse[]>([]);
	private isLoading = $state(false);
	private hasLoaded = $state(false);

	constructor() {
		// Don't fetch automatically in constructor
		// Let the component decide when to fetch
	}

	async fetchPorts() {
		// Prevent multiple concurrent calls
		if (this.isLoading || this.hasLoaded) {
			return;
		}

		this.isLoading = true;
		try {
			const response = await pb.collection(Collections.Ports).getFullList<PortsResponse>();
			this.ports = response;
			this.hasLoaded = true;
		} catch (e) {
			console.error('Error fetching ports:', e);
		} finally {
			this.isLoading = false;
		}
	}
}

const PORTS_KEY = Symbol('PORTS_KEY');

export function setPorts() {
	return setContext(PORTS_KEY, new PortRepository());
}

export function getPortsState() {
	return getContext<ReturnType<typeof setPorts>>(PORTS_KEY);
}
